import { render } from "./textlink.vue?vue&type=template&id=79e1f68b&scoped=true&ts=true"
import script from "./textlink.vue?vue&type=script&lang=ts"
export * from "./textlink.vue?vue&type=script&lang=ts"

import "./textlink.vue?vue&type=style&index=0&id=79e1f68b&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e1f68b"]])

export default __exports__